module.exports = __webpack_public_path__ + "img/history.6afed71a.png";